import React, { createContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  reportListDataFilter,
  getDownloadExcel,
  downloadExcel,
  getExtendedStayData,
  getCategoryList,
  getEmployeeDetail,
  getVisitorsDetails,
  getAllReportedData,
  downloadExtendedStayExcel,
  manulPunchOutUsers,
  downloadExcelReportAll
} from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { Alert } from "react-bootstrap";
import { baseURL } from "../../api/Axios";
export const ReportZoneContext = createContext({});
export const ReportZoneContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromDateReportAll = location.state?.filteredData?.fromDate
  const toDateReportAll = location.state?.filteredData?.toDate
const numberOfPages = location.state?.filteredData?.pageNumbers
  const [pageCount, setPageCount] = useState(1);
  const [currentPageData, setCurrentPageData] = useState(1);
  const [reportZone, setReportZone] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [toDate, setToDate] = useState("");
  const [zoneNewExcel, setZoneNewExcel] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [filterInReportsSpinnerStatus, setFilterInReportsSpinnerStatus] =
    useState(false);
  const [statusCode, setStatusCode] = useState(0);
  const [categoryListDropDown, setCategoryListDropDown] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [filterZone, setFilterZone] = useState({
    id: false,
    name: "All Zones",
  });
  const [filterCategory, setFilterCategory] = useState({
    id: false,
    name: "All Categories",
  });
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");

  const [visibleZone, setVisibleZone] = useState({
    id: false,
    name: "All Zones",
  });
  const [visibleCategory, setVisibleCategory] = useState({
    id: false,
    name: "All Categories",
  });

  const [downloadExcelSpinnerStatus, setDownloadExcelSpinnerStatus] =
    useState(false);

  const goBack = () => {
    navigate(-1);
  };

  // state to store time interval inside filter modal
  const [timeInterval, setTimeInterval] = useState({
    id: "",
    name: "Select Time Interval",
  });

  const [extendStayReport, setExtendStayReport] = useState([]);
  const [downloadExtendReport, setDownLoadExtendReport] = useState("");

  // new changes
  const [selectedExtentdstayRow, setSelectedExtentdstayRow] = useState([]);
  // Taking the id value of extended stay that get from report page dropdown
  const [logoutSpinner, setLogoutSpinner] = useState(false);
  const reportCriteria = location?.state?.filterCriteria?.id;
 
  const datefrom = location?.state?.filterCriteria
  const [reportAllDownload, setReportAllDownload] = useState(""); 
  const zoneReportData = () => {
    const apiResponseFromState = location?.state?.filteredData;
    setReportZone(apiResponseFromState?.result?.data?.result);
    setFromDate(apiResponseFromState?.fromDate);
    setToDate(apiResponseFromState?.toDate);
    setPageCount(apiResponseFromState?.result?.data?.numPages);
  };

  const downloadExcelSheet = async (zone, id) => {
  
    // search: "report",
    // filter: "visitor",
    // empData: "",
    // fromDate: fromDate,
    // toDate: toDate,
    // zoneFilter: "",
    // categoryFilter: "",
    // visitorType: searchCategory,

    const data = {
      search: "report",
      filter:reportCriteria,  //"zone",
      empData: "",
      fromDate: fromDate,
      toDate: toDate,
      zoneFilter: zone ? zone : "",
      categoryFilter: id ? id : "",
      visitorType:""
    };
    setDownloadExcelSpinnerStatus(true);

    try {
      const response = await getDownloadExcel(data);
      if (response.data.status === 200) {
       setDownloadExcelSpinnerStatus(false);
        // setZoneNewExcel(response?.data?.data?.filename);
        const link = document.createElement('a');
        link.href = `${baseURL}/excel/${response?.data?.data?.filename}`;
        link.click();
      }
    } catch (error) {
      setDownloadExcelSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    zoneReportData();
    // storing the extended stay report data that get from report selecting page
    const extendStayData = location?.state?.extendData;
 
    const extendedDetails = extendStayData?.map((item) => {
      //return item;
      return {
        Id: item?.Id,
        dataType: item?.dataType,
        EmployeeCode: item?.empCode,
        EmployeeName: item?.empName,
        category: item?.category,
        contact: item?.contact,
        vehicle_no: item?.VehicleNo,
        zone: item?.zone,
        in_out: item?.in_out,
        date: moment(item.LogDate).format("MM/DD/YYYY"),
        time: moment(item.LogDate).format("h:mm:ss"),
        magneticId: item?.magneticId,
      };
    });
    setExtendStayReport(extendedDetails);

    setTimeInterval({
      id: 24,
      name: "24 hours",
    });
  }, []);

  // Extended stay report download fuction
  useEffect(() => {
    
  // downloadExtendStayReport(convertTime);
   
  }, [timeInterval]);

  const dataFilteredZone = async (
    pageNumber,
    zone,
    id,
    passedFromDate,
    passedToDate
  ) => {
    const data = {
      page: pageNumber,
      filter: reportCriteria,  //"zone",
      fromDate: passedFromDate,
      toDate: passedToDate,
      categoryFilter: id,
      zone: zone,
    };
  
    setFromDate(passedFromDate);
    setToDate(passedToDate);
    setFilterInReportsSpinnerStatus(true);
    try {
      const response = await reportListDataFilter(data);
      if (response.data.status === 200) {
        setFilterInReportsSpinnerStatus(false);
        setShowModal(false);
        setReportZone(response?.data?.data?.result?.data?.result);
        setPageCount(response?.data?.data?.result?.data?.numPages);
        setCurrentPageData(pageNumber);
      }
    } catch (error) {
      setFilterInReportsSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };
  /**************report all ***********/
  const dataFilteredByAll = async (
    pageNumber,
    passedFromDate,
    passedToDate,
    zone,
    id
  ) => {
   
    const data = {
      page: pageNumber,
      filter: "all",
      fromDate:fromDate , //passedFromDate,
      toDate: toDate //passedToDate,
    };
 
    setFromDate(passedFromDate);
    setToDate(passedToDate);
    setFilterInReportsSpinnerStatus(true);
   
    try {
      const response = await getAllReportedData(data);
      if (response.data.status === 200) {
        setFilterInReportsSpinnerStatus(false);
        setShowModal(false);
        setReportZone(response?.data?.data?.result?.data?.result);
        setPageCount(response?.data?.data?.result?.data?.numPages);
        setCurrentPageData(pageNumber);
      }
    } catch (error) {
      setFilterInReportsSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    setFilterFromDate(fromDate);
    setFilterToDate(toDate);
   
  }, [fromDate, toDate]);

  const onPageChange = (e) => {

    setCurrentPageData(e);
    if (reportCriteria == "zone") {
      dataFilteredZone(e, filterZone.id, filterCategory.id, fromDate, toDate);
    } else if (reportCriteria == "all") {
      dataFilteredZone(e, filterZone.id, filterCategory.id, fromDate, toDate);
      //dataFilteredByAll(e,fromDate, toDate);
    } else {
      externalDataSubmit(e);
      
    }

  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };
  // useEffect(() => {
  //   if (filterCategory && filterZone && fromDate && toDate) {
  //     downloadExcelSheet(filterZone.id, filterCategory.id);
  //   }
  // }, [filterCategory, filterZone, fromDate, toDate]);

  // function to subtract selected hours from current time
  const subtract = timeInterval?.id
    ? moment().subtract(timeInterval?.id, "hours").format("YYYY-MM-DD HH:mm:ss")
    : null;
  const convertTime = subtract
    ? subtract.replace(/ /g, "%20").replace(/:/g, "%3A")
    : "";

  // function to filter by time interval
  const onSubmitTimeInterval = async (pageNumber) => {
    typeof pageNumber == "object" ? (pageNumber = 1) : pageNumber;
    setFilterInReportsSpinnerStatus(true);
    setCurrentPageData(1);
    const data = {
      page: pageNumber,
      time: convertTime,
    };
    try {
      const response = await getExtendedStayData(data);
      if (response?.status === 200) {
        setFilterInReportsSpinnerStatus(false);
        const submitIntervalDetails =
          response?.data?.data?.result?.data?.result?.map((item) => {
            //return item;
            return {
              Id: item?.Id,
              dataType: item?.dataType,
              EmployeeCode: item?.empCode,
              EmployeeName: item?.empName,
              category: item?.category,
              contact: item?.contact,
              vehicle_no: item?.VehicleNo,
              zone: item?.zone,
              in_out: item?.in_out,
              date: moment(item.LogDate).format("MM/DD/YYYY"),
              time: moment(item.LogDate).format("h:mm:ss"),
            };
          });
        setPageCount(response?.data?.data?.result?.data?.numPages);
        setExtendStayReport(submitIntervalDetails);
        setShowModal(false);
        //setTimeInterval({ id: "", name: "Select Time Interval" });
      }
    } catch (error) {
      setFilterInReportsSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const externalDataSubmit = async (pageNumber) => {
    setFilterInReportsSpinnerStatus(true);

    const data = {
      page: pageNumber,
      time: convertTime,
    };
    try {
      const response = await getExtendedStayData(data);

      if (response?.status === 200) {
        setFilterInReportsSpinnerStatus(false);
        const extendedDetails = response?.data?.data?.result?.data?.result?.map(
          (item) => {
            //return item;
            return {
              Id: item?.Id,
              dataType: item?.dataType,
              EmployeeCode: item?.empCode,
              EmployeeName: item?.empName,
              category: item?.category,
              contact: item?.contact,
              vehicle_no: item?.VehicleNo,
              zone: item?.zone,
              in_out: item?.in_out,
              date: moment(item.LogDate).format("MM/DD/YYYY"),
              time: moment(item.LogDate).format("h:mm:ss"),
              magneticId: item?.magneticId,
            };
          }
        );
        setPageCount(response?.data?.data?.result?.data?.numPages);
        setExtendStayReport(extendedDetails);
        setShowModal(false);
      }
    } catch (error) {
      setFilterInReportsSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const callCategoryList = async () => {
    try {
      const getData = await getCategoryList();
      if (getData.data.status === 200) {
        setCategoryListDropDown(getData?.data?.data?.categories);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  useEffect(() => {
    callCategoryList();
    downloadReportAll()
  }, []);

  useEffect(() => {
    if (reportCriteria == "extendedStay")
      setPageCount(location?.state?.pageNumbers);
  }, []);

  // on click name showing details function
  const viewDetails = async (Id, dataType) => {
    if (dataType === "emp") {
      try {
        const response = await getEmployeeDetail(Id);
        if (response?.status === 200) {
          navigate(RouteConstants.EMPLOYEE_DETAILS, {
            state: Id,
          });
        }
      } catch (error) {
        setStatusCode(error?.response?.data?.status);
        if (error?.response?.data?.status === 401) {
          setShowAlert(true);
          setAlertMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 400) {
          setShowAlert(true);

          setAlertMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 403) {
          setShowAlert(true);

          setAlertMessage(error?.response?.data?.message);
        } else {
          setShowAlert(true);

          setAlertMessage("Something went wrong");
        }
      }
    } else if (dataType === "vis") {
      try {
        const response = await getVisitorsDetails(Id);
        const visitorInfo = response?.data?.data;
        navigate(RouteConstants.VISITORS_DETAILS, {
          state: { visitorInfo: visitorInfo, visitorId: Id },
        });
      } catch (error) {
        setDownloadExcelSpinnerStatus(false);
        setStatusCode(error?.response?.data?.status);
        if (error?.response?.data?.status === 401) {
          setShowAlert(true);
          setAlertMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 400) {
          setShowAlert(true);

          setAlertMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 403) {
          setShowAlert(true);

          setAlertMessage(error?.response?.data?.message);
        } else {
          setShowAlert(true);

          setAlertMessage("Something went wrong");
        }
      }
    }
  };

  // Default 24 hour time for extended stay download with out filter
  const downloadTime = moment()
    .subtract(24, "hours")
    .format("YYYY-MM-DD HH:mm:ss");
  const newTime = downloadTime.replace(/ /g, "%20").replace(/:/g, "%3A");

  const downloadExtendStayReport = async (time) => {
    
    const data = {
      search: "report",
      filter:  "extendedStay",
      time: time ? time : newTime,

    };
    setDownloadExcelSpinnerStatus(true);
    try {
      const response = await downloadExtendedStayExcel(data);
      if (response?.status === 200) {
        setDownloadExcelSpinnerStatus(false);
        setDownLoadExtendReport(response?.data?.data?.filename);
        // Trigger file download
        const link = document.createElement('a');
        link.href = `${baseURL}/excel/${response?.data?.data?.filename}`;
        link.click();
        // setDownloadExcelSpinnerStatus(false);
        // setDownLoadExtendReport(response?.data?.data?.filename);
      }
    } catch (error) {
      setDownloadExcelSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };
  // down excel  for report all case 
  const downloadReportAll = async () => {
    const data = {
      search: "report",
      filter:  "all",
      fromDate: fromDateReportAll, //moment(fromDate).format("YYYY-MM-DD"),
      toDate:  toDateReportAll, //moment(toDate).format("YYYY-MM-DD")
      zoneFilter: "",
      categoryFilter: "",
      visitorType:""
    };

    setDownloadExcelSpinnerStatus(true);
   
    try {
      const response = await downloadExcelReportAll(data);
      if (response?.status === 200) {
        setDownloadExcelSpinnerStatus(false);
        setReportAllDownload(response?.data?.data?.filename);
      }
    } catch (error) {
      setDownloadExcelSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const handleCheckboxChange = (row) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.some((selectedRow) => selectedRow.Id === row.Id)) {
        return prevSelectedRows.filter(
          (selectedRow) => selectedRow.Id !== row.Id
        );
      } else {
        return [...prevSelectedRows, row];
      }
    });
   
  // setSelectedRows.push(selectedRows);
  };
  const punchoutUsersManualy = async (selectedRows) => {
    //setFilterInReportsSpinnerStatus(true);

    const transformData = (userdetails) => {
      return {
        users: userdetails.map((userDetails) => {
          return {
            userType: userDetails.dataType,
            employeeCode: userDetails.EmployeeCode,
            magneticId: userDetails.magneticId,

            zone: userDetails.zone,
          };
        }),
      };
    };
   
    const transformedData = transformData(selectedRows);
  
    try {
      
      const getData = await manulPunchOutUsers(transformedData);
      if (getData.data.status === 200) {
        setStatusCode(getData.data.status);
        setExtendStayReport(extendStayReport);
        const data = {
          page: numberOfPages,
          time: convertTime,
        };
       
        const response = await getExtendedStayData(data);
        navigate(
          RouteConstants.REPORT_ZONE,
          {
            state: {
              ...location?.state,
              extendData: response?.data?.data?.result?.data?.result,
              currentPage:numberOfPages,
            },
          },
          { replace: true }
        );

        const extendedDetailsUpdated =
          response?.data?.data?.result?.data?.result?.map((item) => {
            return {
              Id: item?.Id,
              dataType: item?.dataType,
              EmployeeCode: item?.empCode,
              EmployeeName: item?.empName,
              category: item?.category,
              contact: item?.contact,
              vehicle_no: item?.VehicleNo,
              zone: item?.zone,
              in_out: item?.in_out,
              date: moment(item.LogDate).format("MM/DD/YYYY"),
              time: moment(item.LogDate).format("h:mm:ss"),
            };
          });

        setExtendStayReport(extendedDetailsUpdated);
        
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;
        setShowAlert(true);
        setAlertMessage(error.response.data.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };
  const handleLogoutClick = async () => {
    if (selectedRows.length === 0) {
      setShowAlert(true);
      setAlertMessage("Please select any user");
    } else {
    
      setLogoutSpinner(true);
      await punchoutUsersManualy(selectedRows);
      setLogoutSpinner(false);
      setShowAlert(true);
      setAlertMessage("User(s) successfully punched out");
      setCurrentPageData(1)
    }
  };
  const onDownloadClick =()=>{

    downloadExtendStayReport(convertTime);
  }
  const onDownloadAllCatogoryClick =()=>{

    downloadExcelSheet(filterZone.id, filterCategory.id);
  }
  const providerValue = {
    goBack,
    reportZone,
    zoneReportData,
    fromDate,
    toDate,
    onPageChange,
    currentPageData,
    pageCount,
    showModal,
    setShowModal,
    filterZone,
    setFilterZone,
    zoneNewExcel,
    filterCategory,
    setFilterCategory,
    filterFromDate,
    setFilterFromDate,
    filterToDate,
    setFilterToDate,
    dataFilteredZone,
    dataFilteredByAll,
    filterInReportsSpinnerStatus,
    downloadExcelSpinnerStatus,
    visibleZone,
    setVisibleZone,
    visibleCategory,
    setVisibleCategory,
    logout,
    setShowAlert,
    showAlert,
    alertMessage,
    statusCode,
    categoryListDropDown,
    reportCriteria, // extended day
    timeInterval, // time interval state
    setTimeInterval, // time interval set state
    extendStayReport, // extended stay report data
    onSubmitTimeInterval, // time interval filter submit function
    viewDetails, // on click name detail showing function
    downloadExtendReport, // extended report download data storing state,
    selectedExtentdstayRow,
    setSelectedExtentdstayRow,
    handleCheckboxChange,
    selectedRows,
    setSelectedRows,
    setAlertMessage,
    punchoutUsersManualy,
    setStatusCode,
    logoutSpinner, setLogoutSpinner,
    handleLogoutClick,
    setReportAllDownload ,reportAllDownload,
    onDownloadClick,
    onDownloadAllCatogoryClick
  };
  return (
    <ReportZoneContext.Provider value={providerValue}>
      {children}
    </ReportZoneContext.Provider>
  );
};
